// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"749ffcf5","455":"156ebd54"}[chunkId] + ".chunk.js";
};